import React from 'react'

import { writeFile, readFile } from '@utils/fs-helpers'

import {
  getEntity,
  getHeaderData,
  getFooterData,
  getStatementsProductCategoriesData,
} from '@api/index'

import { default as normalizeHeaderData } from '@models/Header'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import { default as normalizeArchiveStatements } from '@models/ArchiveStatements'
import { default as normalizeDocumentProduct } from '@models/DocumentProduct'

import { Col, Container, Row } from '@/atoms/Grid'
import { ArchiveList, ArchiveSidebar } from '@/organisms'

import Layout from '@/organisms/Layout'
import Breadcrumb from '@/molecules/Breadcrumb'

export const getStaticPaths = async () => {
  const statements = await Promise.all(
    [{ entity: 'statements' }].map(({ entity }) => getEntity({ entity }))
  )

  const paths = statements.reduce((acc, { data }) => {
    if (!data) return acc

    const pathData = Array.isArray(data) ? data : [data]
    const paths = pathData.map(({ categories }) => {
      return categories.map(({ slug }) => {
        return {
          params: {
            slug,
          },
        }
      })
    })

    return [...acc, ...paths]
  }, [])

  try {
    const pagesCache = statements.reduce((acc, { data, entity }) => {
      if (!data || data.length === 0) return acc

      const pathData = Array.isArray(data) ? data : [data]
      const paths = pathData.map(({ categories }) => {
        return categories.map(({ slug }) => {
          return {
            slug,
            entity,
          }
        })
      })

      return [...acc, ...paths]
    }, [])

    await writeFile(
      'cache/static-paths-product-statements.json',
      JSON.stringify(...pagesCache),
      'utf-8'
    )
  } catch (error) {
    console.error('Generate cache file error', error)
  }

  return {
    paths: paths[0],
    fallback: false,
  }
}

export const getStaticProps = async ({ params }) => {
  const cacheFile = await readFile(
    'cache/static-paths-product-statements.json',
    'utf-8'
  )
  const staticPaths = JSON.parse(cacheFile)

  const { slug } = staticPaths.find((path) => {
    const slug = Array.isArray(path.slug) ? path.slug.join('/') : path.slug
    return slug === `${params.slug}`
  })

  const [header, footer, data] = await Promise.all([
    getHeaderData(),
    getFooterData(),
    getStatementsProductCategoriesData(),
  ])

  let statements = null
  data.categories.map((el) => {
    if (el.slug == slug) {
      statements = el
      el.isActive = true
    }
  })
  const normalizedDocs = normalizeDocumentProduct(statements)

  return {
    props: {
      metadata: {
        metaTitle: `${normalizedDocs.name} - Categoria Prospetti e Rendiconti`,
      },
      breadcrumb: normalizeBreadcrumb([
        {
          label: 'Prospetti e Rendiconti',
          href: '/prospetti-e-rendiconti',
        },
        {
          label: normalizedDocs.name,
        },
      ]),
      footer: normalizeFooterData(footer),
      header: normalizeHeaderData(header),
      content: normalizeArchiveStatements(data),
      list: {
        entity: 'prospetti-e-rendiconti',
        type: 'grid',
        categories: [normalizedDocs],
        backButton: true,
        backButtonLabel: "Indietro",
      },
    },
  }
}

const CategoryStatements = ({
  metadata,
  breadcrumb,
  header,
  footer,
  content,
  list,
}) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='primaryLight'
    >
      <Breadcrumb items={breadcrumb} />
      <Container>
        <Row>
          <Col
            xs={12}
            lg={4}
          >
            <ArchiveSidebar
              {...content.sidebar}
              entity='prospetti-e-rendiconti'
            />
          </Col>
          <Col
            xs={12}
            lg={8}
          >
            <ArchiveList {...list} />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default CategoryStatements
